module.exports = __webpack_public_path__ + "static/media/edit-pencil.34f5b306.svg";